import React from 'react';
import {Field} from 'redux-form/immutable';
import {SelectField} from 'redux-form-antd'
import {
    required,
    nullValue1
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const SseFarther = props => {
    const ans = '父管教方式'
    const select_arr = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '關懷管教'
        },
        {
            value: '2',
            label: '開明管教'
        },
        {
            value: '3',
            label: '權威管教'
        },
        {
            value: '4',
            label: '自主發展'
        },
        {
            value: '5',
            label: '較少陪伴'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label={ans}
                   options={select_arr} name="sse_farther" type="text"></Field>
        </div>
    )
}

export default SseFarther


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseFarther.jsx